
//import resource from './resource.js'
import loader from './loader.js'
import prop from './prop.js'
import position from './position.js'
import other from './other.js'

export default {
  //resource,
  loader,
  prop,
  position,
  other
}
